const initialState = {
  submitting: false,
  successful: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'ADD_OTHER': {
      return {
        ...state,
        submitting: true,
      }
    }
    case 'ADD_OTHER_COMMIT': {
      return {
        ...state,
        successful: true,
        submitting: false,
      }
    }
    case 'ADD_OTHER_ROLLBACK': {
      return {
        ...state,
        successful: false,
        submitting: false,
      }
    }
    default: {
      return state
    }
  }
}
